import { Box } from "@mui/material";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { BoxFC } from "components/BoxCustom";
import React, { useMemo } from "react";
import { columns } from "./columns";
import BillingNoteFilter from "./BillingNoteFilter";
import useBillingNote from "./useBillingNoteManagement";
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor";
import SelectDateDateDialog from "components/dialog/SelectDateDateDialog";
import BillingNoteDialog365 from "./BillingNoteDialog365";

const BillingNoteManagement365 = () => {
  const { state, fn } = useBillingNote();
  const { dataTable, dialogOpen, selectedId, selectionModel, dialogSelectDateOpen, bnIds, oldSndDocDte } = state;


  const modDataTable = useMemo(() => {
    if (dataTable.length > 0 && dataTable[dataTable.length - 1].id === -1) {
      return dataTable
    }
    return addSumRow({
      dataTable: dataTable,
      sumColNms: ["NumInv", "OwnRcptAmnt", "CusRcptAmnt", "Total"],
      sumColTotal: "BNNo"
    })
  }, [dataTable])
  


  const columnsMemo = useMemo(() => columns(fn.handleSendDocDteClick), [fn.handleSendDocDteClick])

  return (
    <BoxFC height="100%">
      <BillingNoteFilter onAddButtonClick={() => fn.openDialog(0)} onSearchButtonClick={fn.getBillingNote} />
      <Box width='100%' mt={2} flexGrow={1} sx={sxSumColorClass}>
        <DataGridCellExpand
          autoHeight hideFooter
          checkboxSelection
          selectionModel={selectionModel}
          onSelectionModelChange={(newSelectionModel) => {
            fn.setSelectionModel(newSelectionModel);
          }}
          rows={modDataTable}
          columns={columnsMemo}
          getRowClassName={getSumColorClassName}
          onRowDoubleClick={(params, event, detail) => fn.openDialog(params.id)} 
          isRowSelectable={(params) => params.id !== 0} />
      </Box>
      <BillingNoteDialog365
        selectedId={selectedId}
        dialogOpen={dialogOpen}
        setDialogOpen={fn.setDialogOpen}
        onFinish={fn.onFinishDialog}
      />
      <SelectDateDateDialog 
        numSelect={bnIds.length}
        dialogOpen={dialogSelectDateOpen}
        setDialogOpen={fn.setDialogSelectDateOpen}
        title="เลือกวันที่ส่งเอกสาร"
        label="วันที่ส่งเอกสาร"
        oldData={oldSndDocDte}
        onFinish={fn.onSelectDateDialogFinish}
      />
    </BoxFC>
  )
}
export default BillingNoteManagement365 
